const config = {
  mode: 'develop',
  api: 'https://dev-api.bdms.tech',
  app: {
    scheme: 'com.bedee.dev',
    screen_name: 'callback',
  },
  otp: {
    code_max_len: 4,
    resend_request_second_time: 180,
    expire_second_time: 180,
  },
}

module.exports = config
